/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Tall_Lynx_TalkInputs */

const en_shy_tall_lynx_talk = /** @type {(inputs: Shy_Tall_Lynx_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributes`)
};

const de_shy_tall_lynx_talk = /** @type {(inputs: Shy_Tall_Lynx_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkmale`)
};

/**
* | output |
* | --- |
* | "Attributes" |
*
* @param {Shy_Tall_Lynx_TalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_tall_lynx_talk = /** @type {((inputs?: Shy_Tall_Lynx_TalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Tall_Lynx_TalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_tall_lynx_talk(inputs)
	return de_shy_tall_lynx_talk(inputs)
});